module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [(_vm.canAddUser) ? _c('v-form', {
    model: {
      value: (_vm.validCustomer),
      callback: function($$v) {
        _vm.validCustomer = $$v
      },
      expression: "validCustomer"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* First Name")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "First Name",
      "rules": _vm.firstNameRule,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-5",
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Create a New Customer"
    },
    model: {
      value: (_vm.canAddUser),
      callback: function($$v) {
        _vm.canAddUser = $$v
      },
      expression: "canAddUser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Surname")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Surname",
      "rules": _vm.surnameRule,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.surname),
      callback: function($$v) {
        _vm.surname = $$v
      },
      expression: "surname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Contact No")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Contact No",
      "rules": _vm.contactNoRule,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.contactNo),
      callback: function($$v) {
        _vm.contactNo = $$v
      },
      expression: "contactNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Username (Email Address)")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Email Address",
      "rules": _vm.usernameRule,
      "browser-autocomplete": "off",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.uName),
      callback: function($$v) {
        _vm.uName = $$v
      },
      expression: "uName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Password")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password",
      "type": "password",
      "browser-autocomplete": "off",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.uPass),
      callback: function($$v) {
        _vm.uPass = $$v
      },
      expression: "uPass"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Confirm Password")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Confirm Password",
      "type": "password",
      "autocomplete": "off",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Alternative Contact No")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "Alternative Contact No",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.alternativeContactNo),
      callback: function($$v) {
        _vm.alternativeContactNo = $$v
      },
      expression: "alternativeContactNo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Rep Code")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "dropdown",
    attrs: {
      "label": "User Rep Code",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.userReference),
      callback: function($$v) {
        _vm.userReference = $$v
      },
      expression: "userReference"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Active for MyOrder")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.activeMyorder),
      callback: function($$v) {
        _vm.activeMyorder = $$v
      },
      expression: "activeMyorder"
    }
  })], 1)], 1)], 1) : (_vm.canAddProject) ? _c('v-form', {
    model: {
      value: (_vm.validProject),
      callback: function($$v) {
        _vm.validProject = $$v
      },
      expression: "validProject"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Create New Project"
    },
    model: {
      value: (_vm.canAddProject),
      callback: function($$v) {
        _vm.canAddProject = $$v
      },
      expression: "canAddProject"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Include for Tendering"
    },
    model: {
      value: (_vm.projectTendering),
      callback: function($$v) {
        _vm.projectTendering = $$v
      },
      expression: "projectTendering"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Tender Closing Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en"
    },
    model: {
      value: (_vm.projectTenderClosingDate),
      callback: function($$v) {
        _vm.projectTenderClosingDate = $$v
      },
      expression: "projectTenderClosingDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Project Name")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Project Name",
      "rules": _vm.projectNameRules,
      "solo": ""
    },
    model: {
      value: (_vm.projectName),
      callback: function($$v) {
        _vm.projectName = $$v
      },
      expression: "projectName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Project Code")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Project Code",
      "solo": ""
    },
    model: {
      value: (_vm.projectCode),
      callback: function($$v) {
        _vm.projectCode = $$v
      },
      expression: "projectCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Project Reference")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Project Reference",
      "solo": ""
    },
    model: {
      value: (_vm.projectReference),
      callback: function($$v) {
        _vm.projectReference = $$v
      },
      expression: "projectReference"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Project Status")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.leadStatusList,
      "rules": _vm.projectStatusRules,
      "autocomplete": "",
      "placeholder": "Status",
      "item-value": "id",
      "item-text": "name",
      "solo": ""
    },
    model: {
      value: (_vm.projectStatus),
      callback: function($$v) {
        _vm.projectStatus = $$v
      },
      expression: "projectStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Project Type")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectTypeList,
      "rules": _vm.projectTypeRules,
      "label": "Project Type",
      "item-value": "id",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.projectType),
      callback: function($$v) {
        _vm.projectType = $$v
      },
      expression: "projectType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Project Professionals")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectSpecifiers,
      "label": "No Specifier Assigned",
      "item-text": "name",
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncChangeSpecifierType
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('small', {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        })]
      }
    }]),
    model: {
      value: (_vm.projectSpecifier),
      callback: function($$v) {
        _vm.projectSpecifier = $$v
      },
      expression: "projectSpecifier"
    }
  })], 1)], 1)], 1) : _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Existing Customer")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.newLeadUsers,
      "rules": _vm.customerRule,
      "autocomplete": "",
      "placeholder": "User",
      "item-value": "userid",
      "item-text": "name",
      "solo": ""
    },
    model: {
      value: (_vm.user),
      callback: function($$v) {
        _vm.user = $$v
      },
      expression: "user"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-5",
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Create a New Customer"
    },
    model: {
      value: (_vm.canAddUser),
      callback: function($$v) {
        _vm.canAddUser = $$v
      },
      expression: "canAddUser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Company")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Lead company",
      "required": "",
      "solo": ""
    },
    model: {
      value: (_vm.company),
      callback: function($$v) {
        _vm.company = $$v
      },
      expression: "company"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Projects")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectList,
      "autocomplete": "",
      "placeholder": "project",
      "item-value": "id",
      "item-text": "name",
      "solo": ""
    },
    model: {
      value: (_vm.project),
      callback: function($$v) {
        _vm.project = $$v
      },
      expression: "project"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-5",
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Create New Project"
    },
    model: {
      value: (_vm.canAddProject),
      callback: function($$v) {
        _vm.canAddProject = $$v
      },
      expression: "canAddProject"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Lead Department")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "solo": "",
      "single-line": "",
      "items": _vm.globalModalParams.departments,
      "rules": _vm.departmentRule,
      "autocomplete": "",
      "multiple": "",
      "placeholder": "Lead Department",
      "item-value": "id",
      "item-text": "name",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckAllDepartments
    },
    model: {
      value: (_vm.department),
      callback: function($$v) {
        _vm.department = $$v
      },
      expression: "department"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Status")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.statusList,
      "rules": _vm.statusRule,
      "autocomplete": "",
      "placeholder": "Status",
      "item-value": "id",
      "return-object": "",
      "item-text": "description",
      "solo": ""
    },
    model: {
      value: (_vm.lead_status),
      callback: function($$v) {
        _vm.lead_status = $$v
      },
      expression: "lead_status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Store")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.storeList,
      "rules": _vm.branchRule,
      "return-object": "",
      "placeholder": "Store",
      "item-value": "id",
      "item-text": "name",
      "solo": ""
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Lead Description")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Lead Description",
      "rules": _vm.departmentRule,
      "required": "",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.lead_description),
      callback: function($$v) {
        _vm.lead_description = $$v
      },
      expression: "lead_description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-2 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), (!_vm.canAddUser && !_vm.canAddProject) ? [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncCreateNewLeadQuote()
      }
    }
  }, [_vm._v("Save")])] : _vm._e(), _vm._v(" "), (_vm.canAddProject && !_vm.canAddUser) ? [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncCreateProject()
      }
    }
  }, [_vm._v("Save")])] : _vm._e(), _vm._v(" "), (_vm.canAddUser && !_vm.canAddProject) ? [_c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncCreateUser()
      }
    }
  }, [_vm._v("Save")])] : _vm._e()], 2)])], 1)
},staticRenderFns: []}